<template v-if="
    regionsStore.allRegions.length > 1
    && regionsStore.showRegions
">
    <div class="mb-1.5 border-b border-gray-300 pb-1.5">
        <h2 class="h6">
            Regions
        </h2>
        <div class="mb-qtr">
            <input
                type="radio"
                id="all-regions"
                name="region"
                value=""
                v-model="regionsStore.chosenRegion"
            >
            <label for="all-regions" class="text-gray-700 ml-qtr">All</label>
        </div>
        <ul>
            <template v-for="region in regionsStore.allRegions">
              
                    <li class="mb-qtr">
                    <input
                        type="radio"
                        v-bind:id="region.id"
                        name="region"
                        v-bind:value="region.id"
                        v-model="regionsStore.chosenRegion"
                    >
                    <label class="text-gray-700 ml-qtr" v-bind:for="region.id">{{region.name}}</label>
                    </li>
               
            </template>
        </ul>
    </div>
</template>
